import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import './Reset-Password.css';


async function sendResetConfirmationEmail(credentials) {
  return await fetch(`${process.env.REACT_APP_API_URL}/user/reset-password`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(credentials),
  });
}

export default function ResetPassword(params) {
  const [password, setPassword] = useState();
  const [searchParams] = useSearchParams();

  const username = searchParams.get('user');
  const resetToken = searchParams.get('token');

  const handleSubmit = async e => {
    e.preventDefault();
    await sendResetConfirmationEmail({
      username,
      password,
      resetToken,
    });

    window.location.href = '/';
  };

  return (
    <div className="login-wrapper">
      <h1>Reset Password</h1>
      <form onSubmit={handleSubmit}>
        <label>
          <p>New Password</p>
          <input type="text" onChange={e => setPassword(e.target.value)} />
        </label>
        <div>
          <button type="submit">Reset Password for {username}</button>
        </div>
      </form>
    </div>
  );
}

ResetPassword.propTypes = {};